export default __webpack_public_path__ + "static/media/errorImage.da212bec.svg";